<template>
    <div class="p-3">
        <h3>RL 3.10 Rekapitulasi Kegiatan Pelayanan Rujukan</h3>
        <hr>
        <DataTable table-id="table-pasien" title="Rekapitulasi Kegiatan Pelayanan Rujukan"
            :filter-configs="filterConfigs" :table-options="tableOptions" :show-filter="true" />
    </div>
</template>

<script>
import DataTable from '@/components/global/DataTable.vue'

export default {
    components: {
        DataTable
    },
    data() {
        return {
            filterConfigs: [
                {
                    id: 'year',
                    label: 'Tahun',
                    field: 'year',
                    type: 'year',
                    colClass: 'col-sm-3',
                    component: 'DropDownYear'
                }
            ],
            tableOptions: {
                baseUrl: '/api/rekapitulasi-pelayanan/kegiatan-pelayanan-rujukan',
                layout: 'fitDataStretch',
                columnMinWidth: 80,
                columns: [
                    {
                        title: "No.",
                        field: "no",
                        width: 80,
                        hozAlign: "left",
                        frozen: true,
                    },
                    {
                        title: "Jenis Kegiatan",
                        field: "jenis_spesialisasi",
                        width: 250,
                        frozen: true,
                    },
                    {
                        title: "Rujukan Diterima Dari",
                        columns: [
                            {
                                title: "Puskesmas",
                                field: "medis_rs",
                                hozAlign: "center",
                            },
                            {
                                title: "RS Lain",
                                field: "medis_puskesmas",
                                hozAlign: "center",
                            },
                            {
                                title: "FasKes Lain",
                                field: "medis_faslain",
                                hozAlign: "center",
                            },
                            {
                                title: "Total Rujukan Masuk",
                                field: "medis_hidup",
                                hozAlign: "center",
                            },
                        ]
                    },
                    {
                        title: "Rujukan Dikembalikan Ke",
                        columns: [
                            {
                                title: "Puskesmas",
                                field: "rujukan_terima_dr_puskesmas",
                                hozAlign: "center",
                            },
                            {
                                title: "RS Lain",
                                field: "rujukan_terima_dr_rs_lain",
                                hozAlign: "center",
                            },
                            {
                                title: "FasKes Lain",
                                field: "rujukan_terima_dr_faskeslain",
                                hozAlign: "center",
                            },
                            {
                                title: "Total Rujukan Masuk",
                                field: "dirujuk_pasien_datang_sendiri",
                                hozAlign: "center",
                            },
                        ]
                    },
                    {
                        title: "Dirujuk Keluar",
                        columns: [
                            {
                                title: "Pasien Rujukan",
                                field: "dirujuk_pasien_rujukan",
                                hozAlign: "center",
                            },
                            {
                                title: "Pasien Datang Sendiri",
                                field: "dirujuk_pasien_datang_sendiri",
                                hozAlign: "center",
                            },
                            {
                                title: "Total Dirujuk Keluar",
                                field: "nonrujukan_total",
                                hozAlign: "center",
                            },
                            {
                                title: "Diterima Kembali",
                                field: "dirujuk_diterima_kembali",
                                hozAlign: "center",
                            }
                        ]
                    }
                ],
                ajaxResponse: (url, params, response) => response
            }
        }
    },
}
</script>
